import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const CodigoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='CÓDIGO' htmlFor='input-codigo' md={12} />
      <Col md={12}>
        <Field name='codigo'>
          {({ field }) => (
            <Form.InputText {...field} isInvalid={iTouched && iError} disabled={fIsSubmitting} id='input-codigo' />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CodigoFormGroup)
